import React from 'react'
import { NavLink } from 'react-router-dom'

const Tab = ({url,img,title,...props}) => {
  return (
    <NavLink to={url} className="nav-link" {...props}>
    <img src={img} alt="" />
    {title}
</NavLink>
  )
}

export default Tab